import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/ravelComponentPath.js';

export class RavelCrossfadeBackground extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container-1 {
            position: fixed;
            top: 0px;
            left: 0px;
            opacity: 1;
        }
        #container-2 {
            top: 0px;
            left: 0px;
            position: fixed;
            opacity: 0;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container-1">
        </div>
        <div id="container-2">
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'backgrounds', 'n-backgrounds', 'speed'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container1 = this.shadowRoot.querySelector('#container-1');
        this.container2 = this.shadowRoot.querySelector('#container-2');
        this.width = '100vw';
        this.height = '100vh';
        this.speed = 31000;
        this.state = 0;
        this.backgrounds = `${ravelComponentPath}/images/default-backgrounds`;
        this.nBackgrounds = 100;
    }
  
    setup = () => {
        //this.observedMessages = ['message'];
        //this.subscribe(this.observedMessages);   
        this.container1.style.width = `${this.width}`; 
        this.container1.style.height = `${this.height}`;
        this.container2.style.width = `${this.width}`; 
        this.container2.style.height = `${this.height}`;
        this.container1.style.backgroundImage = `url(${this.backgrounds}/${Math.floor(Math.random() * this.nBackgrounds)}.png)`;
        this.timer = setInterval(this.toggleBackgroundState, this.speed);
        this.setTransition();
    }

    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }

    setTransition = () => {
        let transitionPeriod = this.speed - 1000;
        if (transitionPeriod <= 0) transitionPeriod = 1000;
        // console.log(transitionPeriod);
        this.container1.style.transition = `opacity ${transitionPeriod}ms ease-out`;
        this.container1.style['-webkit-transition'] = `opacity ${transitionPeriod}ms ease-out`;
        this.container1.style['-moz-transition'] = `opacity ${transitionPeriod}ms ease-out`;
        this.container1.style['-webkit-transition'] = `opacity ${transitionPeriod}ms ease-out`;
        this.container2.style.transition = `opacity ${transitionPeriod}ms ease-out`;
        this.container2.style['-webkit-transition'] = `opacity ${transitionPeriod}ms ease-out`;
        this.container2.style['-moz-transition'] = `opacity ${transitionPeriod}ms ease-out`;
        this.container2.style['-webkit-transition'] = `opacity ${transitionPeriod}ms ease-out`;
    }

    toggleBackgroundState = () => {
        // console.log('toggle background');
        if (this.state == 0) {
            // console.log(`url(${this.backgrounds}/${Math.floor(Math.random() * this.nBackgrounds)}.png`);
            this.container2.style.backgroundImage = `url(${this.backgrounds}/${Math.floor(Math.random() * this.nBackgrounds)}.png)`;
            this.container1.style.opacity = 0;
            this.container2.style.opacity = 1;
            this.state = 1;
        } else {
            // console.log(`url(${this.backgrounds}/${Math.floor(Math.random() * this.nBackgrounds)}.png'`);
            this.container1.style.backgroundImage = `url(${this.backgrounds}/${Math.floor(Math.random() * this.nBackgrounds)}.png)`;
            this.container1.style.opacity = 1;
            this.container2.style.opacity = 0;
            this.state = 0;
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'backgrounds') {
            this.backgrounds = newValue;
        }
        if (name === 'n-backgrounds') {
            this.nbackgrounds = newValue;
        }
        if (name === 'speed') {
            this.speed = Number(newValue);
        }

    }
}